import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import { Post } from '@/types/model';
import { FileText } from 'lucide-react';
import { Typo } from '../ui/typography';
import { BlogPostCard } from './blog-post-card';

interface BlogMasonryGridProps {
  posts: Post[];
  isLoading?: boolean;
  className?: string;
}

export function BlogMasonryGrid({ posts, isLoading = false, className }: BlogMasonryGridProps) {
  if (isLoading) {
    return (
      <div className={cn('columns-1 gap-6 space-y-6 md:columns-2 md:space-y-0 lg:columns-3', 'opacity-50', className)}>
        {Array.from({ length: 6 }).map((_, index) => (
          <BlogPostCardSkeleton key={index} />
        ))}
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <Card className="p-12 text-center">
        <FileText className="text-muted-foreground mx-auto mb-4 h-16 w-16" />
        <Typo variant="h3" className="mb-2">
          Không tìm thấy bài viết nào
        </Typo>
        <Typo variant="muted">Vui lòng thử lại với từ khóa hoặc bộ lọc khác</Typo>
      </Card>
    );
  }

  return (
    <div className={cn('columns-1 gap-6 space-y-6 md:columns-2 md:space-y-0 lg:columns-3', className)}>
      {posts.map((post) => (
        <div key={post.id} className="mb-6 break-inside-avoid">
          <BlogPostCard post={post} />
        </div>
      ))}
    </div>
  );
}

function BlogPostCardSkeleton() {
  return (
    <Card className="mb-6 break-inside-avoid overflow-hidden">
      <Skeleton className="aspect-[4/3] w-full" />
      <CardContent className="space-y-3 p-4">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-6 w-full" />
        <Skeleton className="h-6 w-3/4" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-2/3" />
        </div>
        <Skeleton className="h-4 w-24" />
      </CardContent>
    </Card>
  );
}
